import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Icon } from "./chunk-DKFDJSXF.mjs";

// src/create-icon.tsx
import { forwardRef } from "@chakra-ui/system";
import { Children } from "react";
import { jsx } from "react/jsx-runtime";
function createIcon(options) {
  var _options$viewBox = options.viewBox,
    viewBox = _options$viewBox === void 0 ? "0 0 24 24" : _options$viewBox,
    pathDefinition = options.d,
    displayName = options.displayName,
    _options$defaultProps = options.defaultProps,
    defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps;
  var path = Children.toArray(options.path);
  var Comp = forwardRef(function (props, ref) {
    return /* @__PURE__ */jsx(Icon, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      viewBox: viewBox
    }, defaultProps), props), {}, {
      children: path.length ? path : /* @__PURE__ */jsx("path", {
        fill: "currentColor",
        d: pathDefinition
      })
    }));
  });
  Comp.displayName = displayName;
  return Comp;
}
export { createIcon };